import script from "./HomeBenefits.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeBenefits.vue?vue&type=script&setup=true&lang=js"

import "./HomeBenefits.vue?vue&type=style&index=0&id=c897e0ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c897e0ce"]])

export default __exports__